import React from 'react';
import { SmlsButton, SmlsModal } from '@smiles/smiles-ui-kit-react';
import { ModalBody, ModalFooter } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { TangModalHeader } from '../components/TangModalHeader';
import { LoginModal, useLoginModalFlow } from '../context/LoginModalFlowContext';
import { getLink } from '../../utils';
import { ImageModalWhiteSimpleCellphone } from '../assets/ImageModalWhiteSimpleCellphone';

export function FirstAccessModal() {
  const { t } = useTranslation('modais');

  const modalFlow = useLoginModalFlow();

  function toggleModal() {
    modalFlow.closeModal(LoginModal.FIRST_ACCESS)
  }

  function handleFirstAccessRedirect () {
    window.location.href = getLink('recuperar/primeiro-acesso');
  }
  
  return (
    <SmlsModal
      type="right"
      isOpen={modalFlow.isModalOpen(LoginModal.FIRST_ACCESS)}
      className="tang-modal"
      toggle={toggleModal}
      defaultHeader={false}
    >
      <TangModalHeader showCloseButton onClose={toggleModal} />
      <ModalBody data-testid="modal-body">
        <div className="modal-content">
          <div> 
            <div className="modal-icon">
              <ImageModalWhiteSimpleCellphone />
            </div>
            <p className="modal-title">{t('cadu_first_access.title')}</p>
            <p className="modal-subtitle">{t('cadu_first_access.text')}</p>
          </div>
        </div>
      </ModalBody>
      <ModalFooter className='one-button'>
        <SmlsButton className="button" text={t('cadu_first_access.button_primary')} onClick={handleFirstAccessRedirect} />
      </ModalFooter>
    </SmlsModal>
  );
}
